import { NgModule } from '@angular/core';
import { ScrollTopHistory } from './scroll-top-history';

@NgModule()
export class DfBrowserModule {
    constructor(scrollTopHistory: ScrollTopHistory) {
        scrollTopHistory.appInitialize();
    }
}
